window.domainEmployeeDetailFormatter = function(value, row) {
    let html = '';
    if (row.description) {
        html += '<span class="fw-bold">'+__('Description')+'</span>';
        html += '<p>'+row.description+'</p>';
    }
    return html;
}
